import { InteractionType } from '@azure/msal-browser';
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useMsalAuthentication,
} from '@azure/msal-react';
import { EnvConfig } from '@config';
import { Unauthenticated } from 'components/Unauthenticated';
import { ReactElement, ReactNode, useEffect } from 'react';

// source copied from https://github.com/TotalEnergiesCode/Power2Market-front/blob/f561d2a56123c6d7062dd08668e4badc26cb58f5/src/adapters/secondaries/providers/authentication/authenticationProvider.tsx

function AuthenticationProvider({ children }: WithChildren): ReactElement {
  const { login, error } = useMsalAuthentication(InteractionType.Redirect);

  useEffect(() => {
    const request = {
      scopes: EnvConfig.tokenScopes,
    };
    error && login(InteractionType.Redirect, request);
  }, [error, login]);

  return (
    <>
      <AuthenticatedTemplate>{children}</AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <Unauthenticated />
      </UnauthenticatedTemplate>
    </>
  );
}
export type WithChildren<T = Record<string, unknown>> = T & { children?: ReactNode };

export default AuthenticationProvider;
